const NAME = 'USER_CLASSIFICATIONS/FETCH_USER_CLASSIFICATIONS';

export const FETCH_USER_CLASSIFICATIONS_REQUEST = `${NAME}_REQUEST`;
export const FETCH_USER_CLASSIFICATIONS_SUCCESS = `${NAME}_SUCCESS`;
export const FETCH_USER_CLASSIFICATIONS_FAIL = `${NAME}_FAIL`;

export const fetchUserClassifications = (params, callbacks) => ({
  type: FETCH_USER_CLASSIFICATIONS_REQUEST,
  params,
  callbacks,
});

export const fetchUserClassificationsSuccess = (
  classificationType,
  data
) => ({
  type: FETCH_USER_CLASSIFICATIONS_SUCCESS,
  classificationType,
  data,
});

export const fetchUserClassificationsFail = (
  classificationType,
  error
) => ({
  type: FETCH_USER_CLASSIFICATIONS_FAIL,
  classificationType,
  error,
});

export default {
  FETCH_USER_CLASSIFICATIONS_REQUEST,
  FETCH_USER_CLASSIFICATIONS_SUCCESS,
  FETCH_USER_CLASSIFICATIONS_FAIL,
  fetchUserClassifications,
  fetchUserClassificationsSuccess,
  fetchUserClassificationsFail,
};
